
//compaire function for 2 collections compairing on datetime
const combineByModifiedDate = (collection1, collection2) => {
    if (!collection1 || !collection2) {
        if (collection1) {
            return collection1;
        } else if (collection2) {
            return collection2;
        } else {
            return null;
        }
    } else {
        if (collection1.constructor === Array && collection2.constructor === Array) {
            let tempCollection = [];
            //compare with collection2 incl. date
            collection1.forEach(item1 => {
                let found = collection2.find(item2 => { return (item1.guid === item2.guid && new Date(item1.lastmodified) < new Date(item2.lastmodified)) });
                if (found) {
                    tempCollection.push(found);
                } else {
                    tempCollection.push(item1);
                }
            });
            //check missing items in collection2
            collection2.forEach(item2 => {
                let found = tempCollection.find(item => { return (item.guid === item2.guid) });
                if(!found){
                    tempCollection.push(item2);
                }
            });
            return tempCollection;

        } else if (collection1.constructor === Object && collection2.constructor === Object) {
            if (new Date(collection1.lastmodified) < new Date(collection2.lastmodified)) {
                return collection2;
            } else {
                return collection1;
            }
        } else {
            return null;
        }
    }
}

export default { combineByModifiedDate }